import { useQuery } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import AdminGoalTemplate from '@components/admin/AdminGoalTemplate';
import HandleQuery from '@components/HandleQuery';
import AppPage from '@components/pageTypes/AppPage';
import PageTitle from '@components/text/PageTitle';
import { GetGoalTemplateDocument, GetGoalTemplateQuery, GetGoalTemplateQueryVariables } from '@typing/Generated';

type Props = {
  goalTemplateId: string;
};

const ExpertGoalTemplatePage = ({ goalTemplateId }: Props) => {
  const intl = useIntl();

  const getGoalTemplateQuery = useQuery<GetGoalTemplateQuery, GetGoalTemplateQueryVariables>(GetGoalTemplateDocument, {
    variables: {
      id: goalTemplateId
    }
  });

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: 'pageTitles.expert.goalTemplate.show' })}</title>
      </Helmet>
      <PageTitle imageName="womanPlan" titleKey="pages.expert.goalTemplate.title" />
      <div className="contentSpacing">
        <HandleQuery query={getGoalTemplateQuery}>
          {data => <AdminGoalTemplate goalTemplate={data.goalTemplate} />}
        </HandleQuery>
      </div>
    </AppPage>
  );
};

export default ExpertGoalTemplatePage;
